/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_SwitchInputs */

const zh_account_switch = /** @type {(inputs: Account_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换账号`)
};

const en_account_switch = /** @type {(inputs: Account_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch Account`)
};

const es_account_switch = /** @type {(inputs: Account_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar cuenta`)
};

/**
* | output |
* | --- |
* | "Switch Account" |
*
* @param {Account_SwitchInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const account_switch = /** @type {((inputs?: Account_SwitchInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_SwitchInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_account_switch(inputs)
	if (locale === "en") return en_account_switch(inputs)
	return es_account_switch(inputs)
});